export class BarcodeCoulmnsDto {
    lineNumber: number;
    title: string;
    dataIndex: string;
    span: number;
    showLabel: boolean;
    showBarcode: boolean;
    className?: string;
    render?: (text: any, record: any) => any;
}